import createSvgIcon from "./utils/create_icon"

const ChevronUpLarge = createSvgIcon(<path clipRule="evenodd" d="M3.293 16.707a1 1 0 0 1 0-1.414l8-8a1 1 0 0 1 1.414 0l8 8a1 1 0 0 1-1.414 1.414L12 9.414l-7.293 7.293a1 1 0 0 1-1.414 0z" fill="currentColor" fillRule="evenodd" />, "ChevronUpLarge")
export default ChevronUpLarge
